import gsap from "gsap";
import Animations from "./animations";
import Header from "./header";

const SplitFeature = (() => {

    const SELECTOR_MODULE = ".module-container__split-feature";
    const SELECTOR_ANIMATED_PRODUCT = ".module-container__animated-product";
    const SELECTOR_PRODUCT_TEASER = ".module-container__3-col-product-teaser";

    const initialize = () => {


        const modules = document.querySelectorAll(`${SELECTOR_MODULE}`);

        modules.forEach(module => {



            if (module.classList.contains('module-container__animated-product')) {

                initAnimatedProductAnimations(module);
            }
            if (module.classList.contains('module-container__3-col-product-teaser')) {

                initAnimatedProductTeaserAnimations(module);
            }
            Animations.fouc(module);
        })

    };

    const initializeAnimatedProduct = () => {

        const module = document.querySelector(SELECTOR_ANIMATED_PRODUCT);


        if (!module) return;
        initAnimatedProductAnimations(module);
        Animations.fouc(module);


    };

    const initializeProductTeaser = () => {

        const module = document.querySelector(SELECTOR_PRODUCT_TEASER);

        if (!module) return;

        initAnimatedProductTeaserAnimations(module);
        Animations.fouc(module);


    };

    const initAnimatedProductAnimations = (module) => {


        if (!module) return;


        // animated elements
        const moduleTextContentLeft = module.querySelector('.content__top__left');
        const moduleTextContentRight = module.querySelector('.content__top__right');
        const moduleMedia = module.querySelector('.content__media');
        const moduleSpecs = module.querySelector('.content__specs');



        
        // animation timeline
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: module,
                start: () => `top top+=${Header.getCurrentHeight()}`,
                end: () => "+=" + window.innerHeight * 2,
                pin: true,
                scrub: 1,
                once: false,
                markers: false
            }
        })
            .from(moduleTextContentLeft,
                { autoAlpha: 0, y: 30, duration: 1 },
            )
            .from(moduleTextContentRight,
                { autoAlpha: 0, y: 30, duration: 1 },
                "-=0.5" // overlap (before translate ends)
            )
            .from(moduleMedia,
                { autoAlpha: 0, y: 30, duration: 1 },
            )
            .from(moduleSpecs,
                { autoAlpha: 0, y: 30, ease: "ease.in", duration: .2 },
            )
            .to({}, { duration: 1 }, "+=1")
        /* .scrollTrigger.refresh(); */


        // header elements height + some value
        /* const getOffset = () => Header.getCurrentHeight() - 50; */

        /* Animations.createPin({

            trigger: module,
            start: () => `top-=${getOffset()} top`,
            
            animation: tl,
            

        } )*/


    };

    const initAnimatedProductTeaserAnimations = (module) => {

        if (!module) return;

        // animated elements
        const moduleTextContentLeft = module.querySelector('.content__top__left');
        const moduleTextContentRight = module.querySelector('.content__top__right');
        const moduleTeaser = module.querySelectorAll('.teaser');


        // animation timeline
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: module,
                start: "top bottom-=25%",
                end: "25% center",
                scrub: 0.5,
                once: false,
                /* markers: true */
            }
        })
            .fromTo(moduleTextContentLeft,
                { autoAlpha: 0, y: 30 },
                { autoAlpha: 1, y: 0, ease: "none", duration: 2 },
            )
            .fromTo(moduleTextContentRight,
                { autoAlpha: 0, y: 30 },
                { autoAlpha: 1, y: 0, ease: "none", duration: 1 }

            )
            .fromTo(moduleTeaser,
                {
                    autoAlpha: 0,
                    y: 30,
                },
                {
                    autoAlpha: 1,
                    y: 0,
                    ease: "none",
                    duration: 1,
                    stagger: 0.2,
                })
        /* .scrollTrigger.refresh() */


        // bind hover animation on teaser images
        moduleTeaser.forEach(teaser => {


            teaser.addEventListener('mouseenter', e => {
                const teaserImg = teaser.querySelector('.teaser__content img');
                const animation = hoverAnimation(teaserImg);
                if (animation.isActive()) return;

                animation.restart();
            });

            teaser.addEventListener("touchstart", e => {
                if (animation.isActive()) return;
                e.preventDefault(); // prevents "ghost click"
                animation.restart();
            }, { passive: false });

        })

    };

    const hoverAnimation = (image) => gsap.timeline({
        paused: true,
        defaults: { ease: "power1.inOut" }
    })
        .to(image, { scale: 1.06, duration: 0.3 })
        .to(image, { scale: 1.0, duration: 0.3 });

    return {
        initialize,
        initializeAnimatedProduct,
        initializeProductTeaser
    }

})();


export default SplitFeature;